import graphql from 'babel-plugin-relay/macro'
import { useEffect, useState } from 'react'
import { usePortalMutation } from 'utils'

import { useTrackContactVisitMutation } from './__generated__/useTrackContactVisitMutation.graphql'

const TrackContactVisitMutation = graphql`
  mutation useTrackContactVisitMutation {
    trackContactVisit {
      __typename
    }
  }
`

/** Hook used to track a user visits time. */
const useTrackContactVisit = (hubspotContactId: string | null = null): void => {
  const [track] = usePortalMutation<useTrackContactVisitMutation>(
    TrackContactVisitMutation,
    {
      mutationName: 'TrackContactVisit',
      sentryContext: {
        component: 'useTrackContactVisit',
      },
      showErrorToast: false,
    },
  )
  const [tracked, setTracked] = useState(false)

  useEffect(() => {
    if (hubspotContactId && !tracked) {
      track({ variables: {} })
      setTracked(true)
    }
  }, [hubspotContactId, tracked]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useTrackContactVisit
